export const ORDERED = 'ordered';
export const WAITING_PHOTO = 'waiting_photo';
export const ESTIMATING = 'estimating';
export const ESTIMATED = 'estimated';
export const DONE = 'done';
export const NOT_SUITABLE = 'not_suitable';
export const DECLINED = 'declined';
